import ThankYou from './ThankYou'
import { connect } from 'react-redux'
import * as orderSelectors from '../../selectors/order'

const mapStateToProps = state => ({
  orderConfirmation: orderSelectors.getOrderConfirmation(state),
  selectedDeliveryDay: orderSelectors.getSelectedDeliveryDay(state),
  selectedDeliveryTime: orderSelectors.getSelectedDeliveryTime(state),
  selectedAddress: orderSelectors.getSelectedAddress(state),
  selectedDropoff: orderSelectors.getSelectedDropoff(state)
})

export default connect(mapStateToProps)(ThankYou)



// WEBPACK FOOTER //
// ./src/modules/ThankYou/index.js